import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyEn7() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`VII.`}
            <br />
            {`Copyright and license agreements`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`The User (data subject) acknowledges that all content of the website, i.e. in particular audio and video content, photographs, graphics and other elements contained on the website or available within the service are protected by copyright.`}</li>
            <li>{`Databases located on the website or available within the service are protected by a special right of the acquirer of the database, which is the Provider.`}</li>
            <li>{`Unless otherwise agreed in writing with the Provider, the authorized use of copyrighted works or databases by the User may occur only within the User interface of the service.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`The User is not entitled to copy, store or duplicate the content of the website or service, combine it with other copyrighted works or handle copyrighted works other than by using them within the service. The User is not entitled to bypass the technical means intended to protect the content.`}</li>
            <li>{`The User acknowledges that the computer programs that make up the website are protected by copyright. The User undertakes not to perform any activity that could allow him or third parties to unauthorizedly interfere with or use computer programs where the Provider of property rights is the Provider.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyEn7;
